import script from "./Interests.vue?vue&type=script&setup=true&lang=js"
export * from "./Interests.vue?vue&type=script&setup=true&lang=js"

import "./Interests.vue?vue&type=style&index=0&id=6acf666a&scoped=true&lang=css"

import exportComponent from "/home/kuzma/www/barberteam/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6acf666a"]])

export default __exports__